import { Button } from "@components/Button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@components/Dialog";
import { Typography } from "@components/Typography";

import { deleteGoalByIdMutation } from "@storage/queries/goals";

interface DeleteGoalDialogProps {
	onClose: () => void;
	goalId: string;
	title: string;
}

export const DeleteGoalDialog = ({ onClose, goalId, title }: DeleteGoalDialogProps) => {
	const { mutateAsync: deleteGoal, isPending: isDeleteGoalPending } = deleteGoalByIdMutation();

	const handleDialogOpenChange = (open: boolean) => {
		if (!open) {
			onClose();
		}
	};

	const handleDeleteCurrentGoal = () => {
		deleteGoal(goalId);
		onClose();
	};

	return (
		<Dialog open onOpenChange={handleDialogOpenChange}>
			<DialogContent className="w-110.5 max-w-[calc(100vw-32px)] p-5">
				<div className="flex flex-col gap-5">
					<DialogHeader className="gap-1.25 py-0">
						<DialogTitle className="text-xl leading-6">Delete the goal</DialogTitle>
						<Typography type="p" size="xl" weight="bold" padding="none">
							{title}?
						</Typography>
					</DialogHeader>

					<Typography size="sm" color="grey-tertiary" padding="none" type="p">
						Deleting this goal will remove it and its progress permanently. Cancel active goals with care, as this can
						affect your ongoing show.
					</Typography>

					<div className="flex w-full gap-2">
						<Button wide onClick={handleDeleteCurrentGoal} disable={isDeleteGoalPending}>
							<Typography type="span" size="sm" weight="bold" padding="none">
								Delete
							</Typography>
						</Button>
						<Button wide type="secondary" onClick={onClose}>
							<Typography type="span" size="sm" weight="bold" padding="none">
								Cancel
							</Typography>
						</Button>
					</div>
				</div>
			</DialogContent>
		</Dialog>
	);
};
